import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { DummyComponent } from '../../../shared/dummy.component';
import * as FileSaver from 'file-saver';
import { consts } from '../../../consts';
import { Utils } from '../../../shared/utils';
import { PrestamosService } from './prestamos.service';
import { PrestamosConst } from './prestamos-const';
import { PrestamosModel } from './prestamos.model';
import { PrestamosDialogDeleteComponent } from './prestamos-dialog-delete.component';
import { PrestamosDialogAttachmentComponent } from './prestamos-dialog-attachment.component';
import { PrestamosDialogPagoCuotasComponent } from './prestamos-dialog-pago-cuotas.component';
import { PrestamosDialogDeudaACortoPlazoComponent } from './prestamos-dialog-deuda-a-corto-plazo.component';
import { PrestamosDialogConstitucionComponent } from './prestamos-dialog-constitucion.component';
import { AccountingManualFormComponent } from '../../accounting/manual/accounting-manual-form.component';
import { TableService } from '../../../shared/components/table/table.service';

@Component({
    selector: 'convfact-prestamos-list',
    templateUrl: './prestamos-list.component.html',
    styleUrls: ['./prestamos.component.css'],
    standalone: false
})
export class PrestamosListComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  public headerTable: any[] = PrestamosConst.headerTable;

  public dataSource: PrestamosModel[] = [];

  public empty: boolean = false;
  public ready: boolean = false;
  public spinner: boolean = false;

  public download: boolean = false;
  public empty_guid = consts.EMPTY_GUID;

  constructor(
    private prestamosService: PrestamosService,
    private router: Router,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public dummy: DummyComponent,
    private tableService: TableService
  ) { }

  public ngOnInit(): void {
    this.dataSource = [];
    this.getList();
  }

  public getList() {
    this.prestamosService.list(this.currentPage, this.itemsPerPage)
      .then(data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;
      });
  }

  public pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  public constitucionPrestamos(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo y se lo pasamos al modal de pago
    const prestamosSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(PrestamosDialogConstitucionComponent, {
      width: '90%',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: { prestamos: prestamosSelected }
    })
      .afterClosed().subscribe(() => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public deudaACortoPlazo(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo y se lo pasamos al modal de pago
    const prestamosSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(PrestamosDialogDeudaACortoPlazoComponent, {
      width: '90%',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: { prestamos: prestamosSelected }
    })
      .afterClosed().subscribe(() => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public pagarCuotas(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo y se lo pasamos al modal de pago
    const prestamosSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(PrestamosDialogPagoCuotasComponent, {
      width: '90%',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: { prestamos: prestamosSelected }
    })
      .afterClosed().subscribe(() => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public create() {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.router.navigate([this.router.url + '/create']);
  }

  public edit(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.router.navigate([this.router.url + '/edit' + '/' + uid]);
  }

  public delete(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(PrestamosDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public uploadFileAttachment(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(PrestamosDialogAttachmentComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public downloadFileAttachment(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.prestamosService.downloadFileAttachment(uid).then(response => {
      FileSaver.saveAs(response, Utils.GetFileName("Fichero_Adjunto", consts.EXT_EXCEL));
    })
  }

  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  public addManualAccountMovements(): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog
      .open(AccountingManualFormComponent, {
        width: '60%',
        height: '70%',
        data: {
          accountingMovementId: ''
        }
      })
      .afterClosed().subscribe((result: string) => {
        if (!Utils.IsNullOrEmpty(result)) {
          if (result === 'OK') {
            this.dummy.redirectTo(this.router.url);
          }
        }
      });
  }

  public trackByIndex(i: number) { return i; }

}
